import React from "react";
import cx from "classnames";
import styles from "./Container.module.scss";

export interface ContainerProps extends DefaultProps {
  spacing?: "none" | "small" | "normal" | "large" | "extra" | "fullscreen";
  spacingTopOnly?: boolean;
}
const Container = ({
  children,
  className,
  spacing,
  spacingTopOnly,
  ...props
}: ContainerProps) => (
  <div
    {...props}
    className={cx(
      className,
      styles.container,
      spacing && styles[`spacing-${spacing}`],
      spacingTopOnly && styles.spacingTopOnly
    )}
  >
    {children}
  </div>
);

export default Container;
